import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./languages/en.json";
import de from "./languages/de.json";

export const resources = {
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
};

// Get saved language from localStorage or default to 'de'
const savedLanguage = localStorage.getItem("i18nextLng") || "de";

i18n.use(initReactI18next).init({
  compatibilityJSON: "v3",
  resources,
  defaultNS: "translation",
  fallbackLng: "de",
  lng: savedLanguage,
});

export const handleLanguageChange = (langCode: string) => {
  i18n.changeLanguage(langCode);
  localStorage.setItem("i18nextLng", langCode);
};

export default i18n;
